define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/locale",
	"csi/table/New",
	"csi/xml",
	"./NewSupplierItemMixin",
	"Apparel/DesignatedSupplierMixin"
], function(declare,_,locale,New,xml,NewSupplierItemMixin,DesignatedSupplierMixin) {

	return declare([NewSupplierItemMixin, DesignatedSupplierMixin], {
		bUpdateParent: false,

		/**
		 * @override
		 * Set the parent product and designated supplier on popup view
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			var product = this.m_cache.getParentOfType(this.getParent(), ["Style", "Material"]);
			if (product) {
				// initialize designated supplier
				this.initializeDPSForQuotes(view, "Supplier", product);
				view.setProduct(product);
			}
		},

		/**
		 * @override
		 * Ensure that parent product is in the cache from either the ProductSource or ProductSourcing level
		 */
		onDependencyPaths: function(paths) {
			paths.push(xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT));
		},

		_canNavigate: function() {
			// summary: disable Save & Go since action can create multiple supplier items
			return false;
		},

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd, /*Function*/filter) {
			// avoid duplication of colors / sizes
			fd = fd || this.m_formData; // in case form data isn't loaded yet

			fd.getFieldValue("Colors", true);
			fd.getFieldValue("ProductSizes", true);
			this.inherited(arguments);
		},

		getStringParameters: function() {
			// summary: use return value as parameter to success message
			var supplierItemsCreatedCnt = 0;
			if (this.urlNewItems) {
				supplierItemsCreatedCnt = this.urlNewItems.length;
			}

			return [supplierItemsCreatedCnt.toString()];
		},

		postProcessSuccess: function() {
			this.widget.refreshData();
		}

	});
});
